<div class="row">
  <div class="col col-xs-12 col-sm-12 col-md-12">
    <pr-input-column
      [hidden]="!ibansObects?.length"
      label="Iban existant"
      [derrors]="derrors"
    >
      <!-- [(value)]="selected" -->
      <mat-select
        formControlName="iban"
        (selectionChange)="onInputChange($event)"
      >
        @for (ib of $ibans | async; track ib) {
          <mat-option [value]="ib.iban">
            {{ getOwnerLabel(ib.ownerIds) }} - {{ ib.bankName }} - {{ ib.iban }}
          </mat-option>
        }
      </mat-select>
    </pr-input-column>
  </div>
  <div class="col col-xs-12 col-sm-12 col-md-12">
    <pr-input-column label="Titulaire" [derrors]="derrors">
      <input formControlName="holder" type="text" />
    </pr-input-column>
  </div>
  <div class="col col-xs-12 col-sm-12 col-md-12">
    <pr-input-column label="Domiciliation bancaire" [derrors]="derrors">
      <input formControlName="bankName" type="text" />
    </pr-input-column>
  </div>
  <div class="col col-xs-12 col-sm-12 col-md-12">
    <pr-input-column label="BIC" [derrors]="derrors">
      <input formControlName="bic" type="text" />
    </pr-input-column>
  </div>
  <div class="col col-xs-12 col-sm-12 col-md-12">
    <pr-input-column label="IBAN" [derrors]="derrors">
      <input
        mask="AA00 AAAA AAAA AAAA AAAA AAAA AAAA AAAA AA"
        [showMaskTyped]="true"
        formControlName="iban"
        type="text"
      />
    </pr-input-column>
  </div>
</div>
